export enum PartnerTypeEnum {
    WHITELABEL = 'wl',
    AFFILIATE = 'ap',
    RESELLER = 'res',
}
